import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DayNames from './components/DayNames';
import Week from './components/Week';
import Fa from '../Fa';

import './calendar.css';

export default class Calendar extends Component {
  constructor(props) {
    super(props);
    const date = props.selected || moment().startOf('day');
    this.state = {
      month: date.clone(),
      previousDisabled: this.checkForPreviousOption(date.clone()),
      nextDisabled: this.checkForNextOption(date.clone()),
    };

    this.handlePrevious = this.handlePrevious.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  UNSAFE_componentWillReceiveProps(props) {
    const month = (props.selected || this.state.month).clone();
    this.setState({
      previousDisabled: this.checkForPreviousOption(month),
      nextDisabled: this.checkForNextOption(month),
      month,
    });
  }

  checkForPreviousOption(month) {
    if (this.props.minCurrentDay) {
      return month.isSame(moment(), 'month') && month.isSame(moment(), 'year');
    }
    return false;
  }

  checkForNextOption() {
    return false;
  }

  updatePreviousState(month) {
    this.setState({
      previousDisabled: this.checkForPreviousOption(month),
    });
  }

  updateNextState(month) {
    this.setState({
      nextDisabled: this.checkForNextOption(month),
    });
  }

  handlePrevious() {
    const month = this.state.month.clone();
    month.subtract(1, 'M');
    this.setState({ month });
    this.updatePreviousState(month);
    this.updateNextState(month);
  }

  handleNext() {
    const month = this.state.month.clone();
    month.add(1, 'M');
    this.setState({ month });
    this.updatePreviousState(month);
    this.updateNextState(month);
  }

  handleSelect(day) {
    if (this.props.clickable) {
      this.props.onDateChange(day);
    }
  }

  renderMonthLabel() {
    return (
      <span className="calendar-month-label">
        {this.state.month.locale(moment.locale()).format('MMMM YYYY')}
      </span>
    );
  }

  renderWeeks() {
    const weeks = [];
    let done = false;
    const date = this.state.month.clone().startOf('month').startOf('isoWeek');
    let monthIndex = date.month();
    let count = 0;

    while (!done) {
      weeks.push(
        <Week
          clickable={this.props.clickable}
          minDate={this.props.minDate}
          date={date.clone()}
          key={date.toString()}
          month={this.state.month}
          selected={this.props.selected}
          onDaySelect={this.handleSelect}
        />,
      );
      date.add(1, 'w');
      done = (count += 1) > 2 && monthIndex !== date.month();
      monthIndex = date.month();
    }
    return weeks;
  }

  renderCalendar() {
    return (
      <div className="calendar">
        <div className="calendar-header">
          <div className="calendar-header-content">
            {this.renderMonthLabel()}
            <div className="calendar-icon-navigation">
              <button
                className="calendar-icon-prev"
                disabled={this.state.previousDisabled}
                onClick={this.handlePrevious}
              >
                <Fa icon="angle-left" />
              </button>
              <button
                className="calendar-icon-next"
                disabled={this.state.nextDisabled}
                onClick={this.handleNext}
              >
                <Fa icon="angle-right" />
              </button>
            </div>
          </div>
        </div>
        <DayNames />
        {this.renderWeeks()}
      </div>
    );
  }

  render() {
    return this.renderCalendar();
  }
}

Calendar.propTypes = {
  minCurrentDay: PropTypes.bool,
  minDate: PropTypes.instanceOf(moment),
  clickable: PropTypes.bool,
  selected: PropTypes.instanceOf(moment),
  onDateChange: PropTypes.func.isRequired,
};

Calendar.defaultProps = {
  minCurrentDay: false,
  clickable: true,
};
